<div #container class="canvas-wrapper"   >  
  <canvas class="d-flex" #rendererCanvas id="{{decoration.longId}}"></canvas>  
</div>